import React from "react";
import isotipoHabitia from "../../../assets/isotipo.png";

// Capitulos VII (Personal contratado), VIII (Hall y accesos), IX (Mascotas).
// Render condicional por cap.
export default function AccesosMascotasPage({ config, pagNum, pagTotal, capRomanoMap }) {
  const cv = config.capitulosVisibles;
  const verPC = !!cv.personalContratado;
  const verHA = !!cv.hallAccesos;
  const verMa = !!cv.mascotas;
  const secNum = String(pagNum - 2).padStart(2, "0");
  // Si Sanciones (XVIII) esta visible, referenciamos su nuevo numero romano. Si no, frase generica.
  const refSanciones = capRomanoMap.sanciones
    ? <>según el <b>Capítulo {capRomanoMap.sanciones}</b></>
    : <>según el <b>régimen de sanciones</b></>;

  return (
    <section className="page">
      <div className="page-pad">
        <span className="sec-tag">{secNum} · Accesos y servicios</span>
        <h2 className="big">Accesos y <em>servicios.</em></h2>

        {verPC && (
          <div className="art">
            <div className="art-head">
              <div className="art-num">Capítulo {capRomanoMap.personalContratado}</div>
              <h3 className="art-title">Personal de servicio contratado</h3>
            </div>
            <p className="art-lede">
              Las personas de servicio contratadas por los ocupantes están obligadas a cumplir con las normas aplicables del reglamento. Los ocupantes son responsables ante el edificio por el personal que contraten.
            </p>
          </div>
        )}

        {verHA && (
          <div className="art">
            <div className="art-head">
              <div className="art-num">Capítulo {capRomanoMap.hallAccesos}</div>
              <h3 className="art-title">Hall de entrada y accesos</h3>
            </div>
            <ol className="rules">
              <li><span className="m">a</span><span>El hall, accesos y vía vehicular están restringidos a recibo, tránsito y acceso. <b>Vedado su uso como lugar de juego o reuniones.</b></span></li>
              <li><span className="m">b</span><span><b>Prohibido dejar vehículos sin conductor</b> frente a la explanada principal.</span></li>
            </ol>
          </div>
        )}

        {verMa && (
          <div className="art">
            <div className="art-head">
              <div className="art-num">Capítulo {capRomanoMap.mascotas}</div>
              <h3 className="art-title">Animales domésticos</h3>
            </div>
            <ol className="rules">
              <li><span className="m">a</span><span>Mascotas <b>siempre con correa</b> dentro del edificio.</span></li>
              <li><span className="m">b</span><span>Animales potencialmente agresivos circulan con bozal.</span></li>
              <li><span className="m">c</span><span>Prohibido pasear o que hagan necesidades en áreas comunes.</span></li>
              <li><span className="m">d</span><span>Mantener higiene del ascensor; limpiar suciedad inmediatamente.</span></li>
              <li><span className="m">e</span><span>En ascensores: <b>prioridad de acceso a personas</b>.</span></li>
              <li><span className="m">f</span><span>El responsable debe limpiar las necesidades en lugares comunes.</span></li>
              <li><span className="m">g</span><span>Ladridos o aullidos reiterados: causa de <b>aplicación de multa</b>.</span></li>
            </ol>
            <div className="callout warn">
              <div className="ic">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <path d="M12 3 22 20H2L12 3z" strokeLinejoin="round" />
                  <line x1="12" y1="10" x2="12" y2="14" strokeLinecap="round" />
                  <circle cx="12" cy="17" r="1" fill="currentColor" />
                </svg>
              </div>
              <div>
                <p className="ttl">Sanciones</p>
                <p className="tx">La trasgresión dará lugar a la aplicación de sanciones {refSanciones}.</p>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="pfooter">
        <div className="br"><img src={isotipoHabitia} alt="" />habitia · Reglamento Interno</div>
        <div className="pn">{String(pagNum).padStart(2, "0")} / {String(pagTotal).padStart(2, "0")}</div>
      </div>
    </section>
  );
}
